<template>
  <section>

    <add-application @addedEvent="addedEvent">
      <a href="#" class="btn btn-primary btn-fill">
        <i class="fal fa-plus-circle" />
        {{ $t('TEAM.ADD_APPLICATION') }}
      </a>
    </add-application>

    <b-card no-body class="mt-2"  v-if="items.length !== 0">

      <b-table fixed stacked="md" hover :items="items" :fields="fields">


        <template v-slot:cell(id)="data">
        {{ user.team.dclIdentity }}-{{ data.value }}</template>
        


         <template v-slot:cell(createdDate)="data">
        {{ $moment(data.value) | moment("YYYY-MM-DD HH:mm") }}</template>
        
         <template v-slot:cell(name)="data">
        {{ data.value }}</template>

         <template v-slot:cell(secret)="data">
        {{ data.value }}</template>
        
        <template v-slot:cell(state)="data">
           <b-button size="sm" class="float-right" @click="remove(data.item.id)">
                {{ $t('TEAM.REMOVE_APPLICATION')}}
              </b-button>
        </template>


      </b-table>
      
    </b-card>
    
    <b-card v-if="items.length === 0" class="mt-2" no-body>
      <b-card-body class="m-4">{{ $t('TEAM.NO_APPLICATIONS')}}</b-card-body>
    </b-card>

     <b-pagination
     class="mt-2"
      v-model="currentPage"
      :total-rows="totalItems"
      :per-page="limit"
       align="center"
       @input ="getList"
    >
      <template v-slot:first-text>{{$t("PAGINATION.FIRST")}}</template>
      <template v-slot:prev-text>{{$t("PAGINATION.PREV")}}</template>
      <template v-slot:next-text>{{$t("PAGINATION.NEXT")}}</template>
      <template v-slot:last-text>{{$t("PAGINATION.LAST")}}</template>
    </b-pagination>


  </section>
</template>
<script>
import AddApplication from "@/components/Team/AddApplication";
export default {
  components: {
    AddApplication
  },
  data() {
    return {
      currentPage: 1,
      limit: 10,
      items: [],
      totalItems: 0,
      fields: [        
        {
          key: "createdDate",
          label: this.$t("TEAM.TABLE.CREATED_DATE")
        },
        {
          key: "name",
          label: this.$t("TEAM.TABLE.NAME")
        },
        {
          key: "id",
          label: this.$t("TEAM.TABLE.ID")
        },
        {
          key: "secret",
          label: this.$t("TEAM.TABLE.SECRET")
        },
        {
          key: "state",
          label: ""
        }
      ],
      user: this.$store.state.auth.user
    };
  },
  methods: {
    addedEvent: function() {
      this.getList();
    },
    remove: function(itemId) {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/team/application/remove", {
          itemId: itemId
        })
        .then(function() {
          self.getList();
        })
        .catch(() => {
          self.$noty.error(self.$t("TEAM.ERROR.COULD_NOT_REMOVE_APPLICATION"));
        });
    },
    getList: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/team/application/list", {
          page: this.currentPage,
          limit: this.limit
        })
        .then(response => {
          self.items = response.data.items;
          self.totalItems = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    }
  },
  mounted: function() {
    this.getList();
  }
};
</script>
<style>
</style>